module.exports = __webpack_public_path__ + "img/abs.c85a2ed2.jpg";